var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.3125H1.33333C0.6 0.3125 0.00666666 0.844402 0.00666666 1.4945L0 8.58653C0 9.23663 0.6 9.76853 1.33333 9.76853H12C12.7333 9.76853 13.3333 9.23663 13.3333 8.58653V1.4945C13.3333 0.844402 12.7333 0.3125 12 0.3125ZM12 2.67651L6.66667 5.63152L1.33333 2.67651V1.4945L6.66667 4.44951L12 1.4945V2.67651Z",
    fill: "#B6B8D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnEmail);
export default __webpack_public_path__ + "static/media/icn-email.19f07a0f385d3abffbfb7ce0c77cc91f.svg";
export { ForwardRef as ReactComponent };